<template>
	<Modal :value="visible" title="申述评价·审核结果" width="767" :mask-closable="false" :footer-hide="true"
		class-name="appeal-result-modal" @on-cancel="handleClose">
		<!-- ========== 审核结果状态区（浅橙/浅红背景） ========== -->
		<div v-if="appeal_status === 3" class="result-status-card">
			<div class="status-icon">
				<img src="@/assets/images/icon_close.png" alt="审核不通过" />
			</div>
			<div class="status-title">审核不通过</div>
			<div class="status-meta">
				<span v-if="appealDetail.approve_time">审核时间：{{ appealDetail.approve_time }}</span>
				<span class="reason-meta">平台已驳回本次申述</span>
			</div>
			<div class="reason-reason">
				<span class="reason-label">驳回原因：</span>
				<span class="reason-text">
					{{ appealDetail.approve_content }}
				</span>
			</div>
		</div>
		<div v-if="appeal_status === 2" class="result-status-card success-status-card">
			<div class="status-icon">
				<img src="@/assets/images/icon_success.png" alt="审核通过" />
			</div>
			<div class="status-title">审核通过</div>
			<div class="status-meta">
				<span v-if="appealDetail.approve_time">审核时间：{{ appealDetail.approve_time }}</span>
				<span class="reason-meta">平台已通过本次申述</span>
			</div>
			<div class="reason-reason">
				<span class="success-label">通过原因：</span>
				<span class="reason-text">
					{{ appealDetail.approve_content || '评价内容违规，已折叠' }}
				</span>
			</div>
		</div>
		<div v-if="appeal_status === 1" class="result-status-card">
			<div class="status-title">当前状态：审核中...</div>
			<div class="reason-tips">
				<div>你好！该评论已提交平台，平台将在1-3个工作日内通过平台信息为你反馈结果，</div>
				<div>请耐心等待，期间不可重复发起新申诉 7 日内重新提交申述。</div>
			</div>
		</div>
		<div v-if="appeal_status === 5" class="result-status-card revoke-status-card">
			<div class="status-title">当前状态：已撤销</div>
		</div>

		<!-- ========== 评价信息卡片（灰底） ========== -->
		<div class="review-info-card">
			<div class="info-row">
				<span class="info-label">订单编号：</span>
				<span class="info-value">{{ appealDetail.ord.order_no }}</span>
			</div>
			<div class="info-row">
				<span class="info-label">商品信息：</span>
				<span class="info-value">{{ appealDetail.product.name }} {{ appealDetail.comment.spec_info
					}}</span>
			</div>
			<div class="info-row">
				<span class="info-label">用户信息：</span>
				<span class="info-value">{{ appealDetail.frommember.nickname }}({{ appealDetail.frommember.blur_mobile
					}})</span>
			</div>
			<div class="info-row">
				<span class="info-label">评价详情：</span>
				<span class="info-value">{{ appealDetail.comment.content }}</span>
			</div>
			<!-- 评价图片 -->
			<div class="info-row info-row--images">
				<span class="info-label"></span>
				<div class="review-images">
					<div v-for="(img, index) in appealDetail.comment.image_list" :key="index" class="image-thumb">
						<img v-if="img.type === 'image'" v-viewer :src="img.raw | default_img" alt="评价图片" />
						<img v-if="img.type === 'video'" :src="`${img.raw}?x-oss-process=video/snapshot,t_2000,m_fast,ar_auto`"
							alt="评价视频" @click.stop="previewVideo(img.raw)" />
						<img v-if="img.type === 'video'" src="@/assets/images/icon-play-evaluate.png" class="video-icon"
							alt="视频图标" />
					</div>
				</div>
			</div>
			<div class="info-row">
				<span class="info-label">评论时间：</span>
				<span class="info-value">{{ appealDetail.comment.create_time }}</span>
			</div>
		</div>

		<!-- ========== 申述信息卡片（灰底） ========== -->
		<div class="appeal-info-card">
			<div class="info-row">
				<span class="info-label">申述原因：</span>
				<span class="info-value">{{ appealDetail.appeal_content }}({{ appealDetail.appeal_description }})</span>
			</div>
			<div class="info-row info-row--top">
				<span class="info-label">补充说明：</span>
				<span class="info-value">{{ appealDetail.remark }}</span>
			</div>
		</div>

		<div class="divider-row"></div>
		<!-- ========== 底部按钮 ========== -->
		<div class="modal-footer">
			<div v-if="appeal_status === 3" class="btn-cancel" @click="handleCancel">撤销申述</div>
			<div v-if="appeal_status === 3" class="btn-submit" @click="handleResubmit">补充材料重新申述</div>
			<div v-if="[1, 2, 4, 5].includes(appeal_status)" class="btn-submit btn-tips" @click="handleSubmit">我知道了</div>
		</div>
	</Modal>
</template>

<script>
import { GetShopAppealDetail, RevokeShopAppeal } from '@/api/index.js';
import util from '@/utils/util.js';
export default {
	name: 'AppealReviewStatusModal',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		appeal_id: {
			type: Number,
			default: 0
		},
	},
	computed: {
		// 审核状态直接取详情接口返回的 status，无需父组件传递
		appeal_status() {
			return Number(this.appealDetail.status) || 0;
		}
	},
	watch: {
		visible(newVal) {
			if (newVal) {
				this.getAppealDetail();
			}
		}
	},
	data() {
		return {
			reviewImages: [
				'https://via.placeholder.com/64x64/e8e8e8/666?text=1',
				'https://via.placeholder.com/64x64/e8e8e8/666?text=2',
				'https://via.placeholder.com/64x64/e8e8e8/666?text=3',
				'https://via.placeholder.com/64x64/e8e8e8/666?text=4',
				'https://via.placeholder.com/64x64/e8e8e8/666?text=5'
			],
			appealDetail: {
				comment: {
					image_list: [],
				},
				ord: {},
				seller: {},
				product: {},
				frommember: {},
				shop: {},
			}
		};
	},
	methods: {
		getAppealDetail() {
			GetShopAppealDetail({
				id: this.appeal_id
			}).then(res => {
				if (res.code === 0) {
					this.appealDetail = res.data;
				}
			});
		},
		handleClose() {
			this.$emit('update:visible', false);
			this.$emit('close');
		},
		handleCancel() {
			this.$Modal.confirm({
				title: '确认撤销',
				content: '确定要撤销本次申述吗？撤销后不可恢复。',
				onOk: () => {
					RevokeShopAppeal({
						id: this.appeal_id,
					}).then(res => {
						if (res.code === 0) {
							this.$Message.success('已撤销申述');
							this.handleClose();
							this.$emit('confirm');
						}
					});
				}
			});
		},
		handleResubmit() {
			console.log('补充材料重新申述');
			const data = {
				uuid: this.appealDetail.comment.uuid,
				appeal_id: this.appeal_id,
			}
			this.$emit('showAppealReviewModal', data);
			this.handleClose();
		},
		handleSubmit() {
			// console.log('补充材料重新申述');
			this.handleClose();
		},
		previewVideo(url) {
			util.previewVideo(url);
		}
	}
};
</script>

<style lang="scss" scoped>
/* ============================================
   审核结果状态区（浅橙红背景）
   ============================================ */
.result-status-card {
	background: #fff5f0;
	border-radius: 6px;
	padding: 24px 14px;
	margin-bottom: 16px;
	text-align: center;

	.status-icon {
		margin-bottom: 6px;

		img {
			width: 36px;
			height: 36px;
			object-fit: cover;
		}
	}

	.status-title {
		font-weight: bold;
		font-size: 18px;
		line-height: 27px;
		color: #FF5000;
		text-align: center;
		font-style: normal;
		text-transform: none;
		margin-bottom: 2px;
	}

	.status-meta {
		font-weight: 400;
		font-size: 12px;
		line-height: 18px;
		color: #666666;
		text-align: center;
		font-style: normal;
		text-transform: none;
		margin-bottom: 12px;

		.reason-meta {
			margin-left: 8px;
		}
	}

	.reason-reason {
		display: flex;
		align-items: flex-start;
		font-weight: 400;
		font-size: 14px;
		line-height: 21px;
		text-align: left;
		font-style: normal;
		text-transform: none;

		.reason-label {
			color: #FF5000;
			flex-shrink: 0;
		}
		.success-label {
			color: #008000;
			flex-shrink: 0;
		}
		.reason-text {
			color: #333333;
		}
	}

	.reason-tips {
		font-weight: 400;
		font-size: 14px;
		line-height: 21px;
		color: #666666;
		text-align: center;
		font-style: normal;
		text-transform: none;
	}
}
.success-status-card {
	background: #e6f7e6;
	.status-title {
		color: #008000;
	}
}
.revoke-status-card {
	background: #f5f5f5;
	.status-title {
		color: #666666;
	}
}



/* ============================================
   通用信息卡片（灰底圆角）
   ============================================ */
.review-info-card,
.appeal-info-card {
	background: #F6F7F9;
	border-radius: 6px;
	padding: 16px 14px;
	margin-bottom: 12px;

	.info-row {
		display: flex;
		margin-bottom: 8px;

		&:last-child {
			margin-bottom: 0;
		}

		&--images {
			align-items: flex-start;
		}

		.info-label {
			width: 70px;
			font-weight: 400;
			font-size: 14px;
			line-height: 21px;
			color: #666666;
			text-align: left;
			font-style: normal;
			text-transform: none;
			flex-shrink: 0;
		}

		.info-value {
			font-weight: 400;
			font-size: 14px;
			color: #333333;
			text-align: left;
			font-style: normal;
			text-transform: none;
			flex: 1;
			word-break: break-all;
		}
	}
}

.appeal-info-card {
	margin-bottom: 43px;
}

/* ============================================
   评价缩略图
   ============================================ */
.review-images {
	display: flex;
	gap: 8px;
	flex-wrap: wrap;

	.image-thumb {
		position: relative;
		width: 54px;
		height: 54px;
		background: #D9D9D9;
		border-radius: 4px 4px 4px 4px;
		cursor: pointer;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		.video-icon {
			position: absolute;
			top: 4px;
			right: 4px;
			width: 16px;
			height: 16px;
			object-fit: cover;
		}
	}
}

.divider-row {
	margin: 0 -24px 12px -24px;
	height: 1px;
	background: #e0e0e0;
}

/* ============================================
   底部按钮栏
   ============================================ */
.modal-footer {
	display: flex;
	justify-content: center;
	gap: 10px;

	.btn-cancel {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 118px;
		height: 40px;
		background: #FFFFFF;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #E3E3E3;
		cursor: pointer;

		font-weight: bold;
		font-size: 14px;
		line-height: 21px;
		color: #666666;
		text-align: center;
		font-style: normal;
		text-transform: none;

	}

	.btn-submit {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 148px;
		height: 40px;
		background: #FF5967;
		border-radius: 4px 4px 4px 4px;
		cursor: pointer;

		font-weight: bold;
		font-size: 14px;
		line-height: 21px;
		color: #FFFFFF;
		text-align: center;
		font-style: normal;
		text-transform: none;
	}

	.btn-submit {
		width: 188px;
	}
}
</style>

<!-- 全局样式：覆盖 iView Modal 默认样式 -->
<style lang="scss">
.appeal-result-modal {
	.ivu-modal {
		top: 40px;
	}

	.ivu-modal-header {
		padding: 18px 24px 12px 24px;
		border-bottom: 1px solid #e0e0e0;

		.ivu-modal-header-inner {
			font-weight: bold;
			font-size: 18px;
			// line-height: 27px;
			color: #0F1115;
			text-align: center;
			font-style: normal;
			text-transform: none;
		}
	}

	.ivu-modal-body {
		padding: 12px 24px 24px !important;
		text-align: left;
	}

	.ivu-modal-close {
		top: 16px;
		right: 16px;

		.ivu-icon {
			font-size: 18px;
			color: #999;

			&:hover {
				color: #333;
			}
		}
	}

	/* 隐藏默认 footer（我们自定义了） */
	.ivu-modal-footer {
		display: none;
	}
}
</style>